import { useMemo } from 'react';
import { Attributes } from 'src/components/organisms';
import { Parameter, ParameterBaseProps } from './Parameter';

type RoutingParameterProps = ParameterBaseProps & {
  attributes: Attributes;
  selectedDataSource: string;
};

export const RoutingParameter = (props: RoutingParameterProps) => {
  const { parameterOptions, parameterList } = props;
  const availableParameterOptions = useMemo(() => {
    return parameterOptions.filter(
      (option) => !Object.keys(parameterList).includes(`${option.value}`),
    );
  }, [parameterList, parameterOptions]);

  return (
    <Parameter {...props} isInDraggable options={availableParameterOptions} />
  );
};
